<template>
  <div class="drug-tag">
    <span class="name" :style="{ fontSize: size + 'px' }">
      <span class="tag rx" v-if="product.medicineType === 'RX'">处方药</span>
      {{ product.name || product.goodsName }} {{ product.spec }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 14
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.drug-tag {
  color: #fff;
  @include flex(row);
  align-items: center;
  padding: 0 8px 8px 0;

  .tag {
    margin-right: 4px;
  }

  .rx {
    display: inline-block;
    padding: 2px;
    background: -webkit-linear-gradient(45deg, #0a7ed7, #63b9ff);
    color: #fff;
    border-radius: 2px;
    font-size: 8px;
    position: relative;
    top: -2px;
  }

  .name {
    color: $black1;
    line-height: 1.2;
    @include hiddenText(2);
  }
}
</style>
